import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageMedia } from '../lib/pageMedia';

export function usePageMediaPreload() {
  const { pathname } = useLocation();

  useEffect(() => {
    const manifest = getPageMedia(pathname);
    if (!manifest) return;

    const injectedLinks: HTMLLinkElement[] = [];

    if (manifest.hero) {
      if (manifest.hero.type === 'image') {
        const selector = `link[rel="preload"][as="image"][href="${manifest.hero.url}"]`;
        if (document.querySelector(selector)) return;
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = manifest.hero.url;
        document.head.appendChild(link);
        injectedLinks.push(link);
      }
    }

    return () => {
      for (const link of injectedLinks) link.remove();
    };
  }, [pathname]);
}
